import React from "react";

const TabName = (props) => {
  return (
    <div>
      <label>Tab Name*</label>
      <input
        type="text"
        maxLength="50"
        name="TabName"
        placeholder="Tab Name"
        value={props.name}
        onChange={props.updateTabNameHandler}
        className={
          props.error[props.id] ? "set-width error-input" : "set-width"
        }
      />
      {props.error[props.id] && (
        <label className="error">Mandatory Field.</label>
      )}
      {props.error[props.restrictedErrorId] && (
        <label className="error">
          Please do not name the tab saying Overview, Comment or Notes.
        </label>
      )}
      {props.error[props.uniqueErrorId] && (
        <label className="error">Tab name already exists.</label>
      )}
    </div>
  );
};

export default TabName;
